import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useContexto = (formikRef) => {
  const contextoSelect = useSelect("contexto");
  const [fila, setFila] = useState(null);

  const [contexto, setContexto] = useState(0);
  const [contextos, setContextos] = useState([]);

  useEffect(() => {
    const fetchContextos = async () => {
      const contextosResult = [];
      const query = db.contexto.filter((a) => a.ativo);
      await query.each((contexto) => contextosResult.push(contexto));
      setContextos(contextosResult);
    };

    fetchContextos();
  }, []);
  const optionContextos = useMemo(() => prepareForOptions(contextos, "nome", "id"), [contextos]);

  function onChangeContexto(e) {
    contextoSelect.upDateValue(e.value);
    contextoSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue("contextoId", e.value);
      setTimeout(() => formikRef.current.setFieldTouched("contextoId", true));
    }
    setContexto(e.value);
  }

  function SetSelectContexto(id) {
    if(optionContextos?.length){
      const contexto = optionContextos.find((item) => item.value === id);
      if (contexto)
        onChangeContexto(contexto);

      setFila(null);
    }else{
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionContextos?.length > 0) {
      SetSelectContexto(fila);
    }
  }, [fila, optionContextos])

  return {
    contextos,
    optionContextos,
    onChangeContexto,
    SetSelectContexto,
    contextoSelect,
    contexto
  };
}

export default useContexto;